<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Confirmar pago</h5>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form novalidate [formGroup]="confirmationForm">
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="payment_status_id">Estatus del pago <span class="txt-danger"> *</span></label>
                <select class="col-12 form-select" id="payment_status_id" required formControlName="payment_status_id"
                        [ngClass]="{ 'is-invalid' : (paymentStatus?.touched || validate) && paymentStatus?.errors, 'is-valid' : !paymentStatus?.errors}">
                    <option [ngValue]="null" disabled selected>Motivo de cancelación</option>
                    <option *ngFor="let status of paymentStatusList" [value]="status.id">{{ status.value }}</option>
                </select>
                @if (paymentStatus?.errors) {
                    <div class="invalid-feedback">Selecciona el estatus de pago</div>
                }
            </div>
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="payment_method_id">Forma de pago <span class="txt-danger"> *</span></label>
                <select class="col-12 form-select" id="payment_method_id" required formControlName="payment_method_id"
                        [ngClass]="{ 'is-invalid' : (methodPayment?.touched || validate) && methodPayment?.errors, 'is-valid' : !methodPayment?.errors}">
                    <option [ngValue]="null" disabled selected>Motivo de cancelación</option>
                    <option *ngFor="let method of paymentMethodList" [value]="method.id">{{ method.value }}</option>
                </select>
                @if (methodPayment?.errors) {
                    <div class="invalid-feedback">Selecciona el estatus de pago</div>
                }
            </div>
        </form>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="paymentConfirmation()">Confirmar pago</button>
    </div>
</div>